<template>
    <div class="wrapper">

        <section class="intro politica column-center">
            <h1 class="big-title column-center">
                <span>Buscador</span>
            </h1>
        </section>

        <section class="breadcrumb">
            <nav class="container row-start">
              <router-link to="/">Home</router-link>
              <a>Buscador</a>
            </nav>
          </section>
      

        <buscador></buscador>

        <section class="actividades-list container">

            <template v-if="!!actividades">

                <template v-for="(dia,key) in actividades" v-if="actividades.length != 0">
                    <h2 class="fecha" :data="$route.params.id">{{key | parse}}</h2>

                    <template v-if="dia.length != 0">
                        <actividad-el :key="keyactividad+key" v-for="(actividad,keyactividad) in dia" :data="actividad"
                            :date="dia"></actividad-el>
                    </template>

                </template>

                <h3 v-if="actividades.length == 0" class="no-data" :data="$route.params.id">No hay actividades para las
                    fechas
                    seleccionadas</h3>

            </template>

        </section>

    </div>
</template>

<script>

    import buscador from '@/components/parts/buscador-from-buscador';
    import { mapActions } from 'vuex';

    import actividad from '@/components/parts/actividad-el';

    export default {
        name: 'Buscador',
        mounted() {
            this.setData();
        },
        data() {
            return {
                actividades: '',
                data: {
                    date_start: '',
                    date_end: '',
                    categorie: ''
                },
            }
        },
        methods: {
            ...mapActions(['requestActividades','ordenarActividades']),
            setData() {
                this.data.categorie = this.$route.query.id;
                (!!this.$route.query.date_start) ? this.data.date_start = this.$route.query.date_start : null;
                (!!this.$route.query.date_end) ? this.data.date_end = this.$route.query.date_end : null;
                this.getActividades();
            },
            getActividades() {
            this.requestActividades(this.data).then(r => {
                if (!!r) {
                    // Llamar a ordenarActividades para ordenar las actividades
                    this.ordenarActividades(r).then(actividadesOrdenadas => {
                        this.actividades = actividadesOrdenadas;
                    }).catch(error => {
                        console.error('Error al ordenar las actividades:', error);
                    });
                }
            });
        },
        },
        components: {
            'buscador': buscador,
            'actividad-el': actividad,
        },
        watch: {
            '$route'() {
                this.setData();
            }
        },
        filters: {
            parse(value) {
                let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                let dias = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
                let date = new Date(value);

                return `${date.getDate()} de ${meses[date.getMonth()]} de ${date.getFullYear()}, ${dias[date.getDay()]}`;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/buscador.vue